<script lang="ts">
    import { faCheck, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import { createEventDispatcher } from 'svelte'
    import Fa from 'svelte-fa'
    import type { CreateEntryDto } from '../../modules/financialApi/entries/dto/create-entry.dto'
    import type { Category } from '../../modules/financialApi/categories/category'
    import { EntryTypeEnum } from '../../modules/financialApi/entries/entry.enum'
    const dispatch = createEventDispatcher()

    export let entry: CreateEntryDto
    export let categories: Category[] = []

    function categoryChanged() {
        dispatch('change', entry)
    }
</script>

{#if entry}
    <div class="row ofx-item">
        <div class="col-1">
            {dayjs(entry.paymentAt).format('DD/MM/YY')}
        </div>
        <div class="col nowrap">
            {entry.description}
        </div>
        <div class="col-1 text-end">{(entry.type === EntryTypeEnum.debit ? '-' : '') + entry.value.toFixed(2)}</div>
        <div class="col">
            <select class="form-select form-select-sm" bind:value={entry.categoryId} on:change={categoryChanged}>
                <option value="" />
                {#each categories as category}
                    <option value={category.categoryId}>{category.label}</option>
                {/each}
            </select>
        </div>
        <div class="col-2">
            {#if entry.categoryId}
                <Fa icon={faCheckCircle} /> Importado
            {/if}
        </div>
    </div>
{/if}

<style>
    .ofx-item {
        margin: 0px;
    }
    .ofx-item:nth-child(even) {
        background: #333333;
    }
    .ofx-item:nth-child(odd) {
        background: #2b2b2b;
    }

    .ofx-item > * {
        margin-top: 8px !important;
        margin-bottom: 8px !important;
    }

    .ofx-item .form-select-sm {
        font-size: 13px;
        padding: 2px;
    }
</style>
